import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { getRefreshToken } from 'services/auth';
import { useGetMyClientUser } from 'client-app/api/client-user/use-get-my-client-user';
import { useClientAuthStore } from 'client-app/stores/use-client-auth-store';

export const useInitMyClientUser = () => {
  const refresh = getRefreshToken();
  const [isLoading, setIsLoading] = useState(!!refresh);
  const [enabled, setEnabled] = useState(false);

  const { data, isSuccess, isError } = useGetMyClientUser(enabled);
  const { setAuth, clientUser, isAuth, clearAuth } = useClientAuthStore();

  useEffect(() => {
    if (refresh) {
      setEnabled(true);
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isSuccess) {
      Sentry.setUser({ id: data?.id, email: data?.email, clientId: data?.clientId });
      setAuth(data);
      setIsLoading(false);
    }
    if (isError) {
      clearAuth();
      setIsLoading(false);
    }
  }, [data, isError, isSuccess, setAuth]);

  return { isLoading, clientUser, isAuth };
};
